(function () {
  'use strict';

  /* En-tête : réduction au scroll via IntersectionObserver.
     Pas d'écouteur scroll — le wordmark passe de grand à réduit une seule fois. */
  var sentinelle = document.querySelector('[data-sentinelle-entete]');
  var entete = document.querySelector('[data-entete]');
  if (sentinelle && entete && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entrees) {
      entete.classList.toggle('entete--reduit', !entrees[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(sentinelle);
  }

  /* Tiroir mobile */
  var tiroir = document.querySelector('[data-tiroir]');
  var ouvrir = document.querySelector('[data-ouvrir-menu]');
  function basculer(etat) {
    if (!tiroir) return;
    tiroir.hidden = !etat;
    document.body.style.overflow = etat ? 'hidden' : '';
    if (ouvrir) ouvrir.setAttribute('aria-expanded', String(etat));
    if (etat) {
      var f = tiroir.querySelector('[data-fermer-menu]');
      if (f && f.focus) f.focus();
    } else if (ouvrir) { ouvrir.focus(); }
  }
  if (ouvrir) ouvrir.addEventListener('click', function () { basculer(true); });
  document.querySelectorAll('[data-fermer-menu]').forEach(function (el) {
    el.addEventListener('click', function () { basculer(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && tiroir && !tiroir.hidden) basculer(false);
  });

  /* Bandeau d'annonce : navigation manuelle uniquement, pas de rotation
     automatique — un message qui défile tout seul se lit mal et n'apporte rien. */
  var bandeau = document.querySelector('[data-bandeau]');
  if (bandeau) {
    var msgs = Array.prototype.slice.call(bandeau.querySelectorAll('[data-msg]'));
    var i = 0;
    function aller(n) {
      if (!msgs.length) return;
      i = (n + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) { m.hidden = k !== i; });
    }
    var p = bandeau.querySelector('[data-bandeau-prec]');
    var s = bandeau.querySelector('[data-bandeau-suiv]');
    if (p) p.addEventListener('click', function () { aller(i - 1); });
    if (s) s.addEventListener('click', function () { aller(i + 1); });
  }

  /* Méga-menu : ouverture au clavier sur les entrées parentes */
  document.querySelectorAll('.nav__item--mega > .nav__lien').forEach(function (lien) {
    lien.addEventListener('focus', function () { lien.setAttribute('aria-expanded', 'true'); });
    lien.closest('.nav__item').addEventListener('focusout', function (e) {
      if (!e.currentTarget.contains(e.relatedTarget)) lien.setAttribute('aria-expanded', 'false');
    });
  });
})();
